export default __webpack_public_path__ + "images/d0a538dbacce427922e2e161a73db900.svg";